import React from 'react'

import { BillingPresentation } from './index'
import { InvoiceHistory } from 'components/InvoiceHistory'
import '@stripe/stripe-js'

/**
 * @param {object} props
 * @param {object} props.user
 * @param {object} props.billing
 * @param {object} props.plans
 */
export function BillingContainer({ user, billing, plans }) {
  return (
    <React.Fragment>
      <BillingPresentation billing={billing} user={user} plans={plans} />

      <h3>Invoice history</h3>
      <InvoiceHistory invoices={billing.invoices} />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/Billing/container.js